var map = {
	"./Background1.jpg": "4478",
	"./Header1.jpg": "8f09",
	"./Header1Kopf.jpg": "00e3",
	"./Header2.jpg": "a10f",
	"./Header2Kopf.jpg": "41ca",
	"./Header3.jpg": "ed66",
	"./Header3Kopf.jpg": "026c",
	"./Header4.jpg": "fa98",
	"./Header4Kopf.jpg": "b02a",
	"./Header5.jpg": "f84e",
	"./Header5Kopf.jpg": "c11a",
	"./HotelJHV24.jpg": "2f41",
	"./Kortlueke.jpg": "7090",
	"./Kortlueke2.jpg": "0bfa",
	"./Sonder2017.jpg": "d576",
	"./Sonder2018.jpg": "4c1f",
	"./Sonder2019.jpg": "dee6",
	"./Sonder2021.jpg": "5392",
	"./Sonder2022.jpg": "c512",
	"./ZAG-Bild.jpg": "d5a9",
	"./loseblatt1.jpg": "745d",
	"./loseblatt2.jpg": "e6d5",
	"./loseblatt3.jpg": "d0ce",
	"./slider1.jpg": "4dce",
	"./slider2.jpg": "9a02",
	"./slider3.jpg": "5316",
	"./slider4.jpg": "7bb4",
	"./slider5.jpg": "2343",
	"./slider6.jpg": "3174"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "416a";